import { addClasses } from '../utils/html';

/* eslint-disable no-console, key-spacing, no-multi-spaces, no-magic-numbers */

const SEC   = 1000;
const MIN   = SEC * 60;
const HOUR  = MIN * 60;
const DAY   = HOUR * 24;
export class CountdownTimer {

  /**
   * The Countdown Timer component
   *
   * @param {Element} timer DOM element that the timer should be injected into
   * @return void
   */
  constructor(elem, { startDate, endDate, extended = false, compact = false, dark = false }) {
    console.warn('Timer.constructor:', elem, startDate, endDate);
    this.container = elem;
    this.startDate = startDate;
    this.endDate = endDate;
    this.extended = extended;
    this.compact = compact;
    this.dark = dark;

    if (!this.isEverythingOk()) {
      return;
    }

    this.stages = [
			{ color: '#fa0033', percentRemaining: 10 },
			{ color: '#f68b1f', percentRemaining: 25 },
			{ color: '#bfd730', percentRemaining: 50 },
			{ color: '#8ebe3f', percentRemaining: 100 },
    ];

    this.init();
  }

  init() {
    this.createDomElements(this.container);
    this.startTimer();
  }

  createDomElements(container) {
    const timerEl           = document.createElement('div');
    const timerPartsEl      = document.createElement('div');
    const timerDurationEl   = document.createElement('div');
    const timerRemainingEl  = document.createElement('div');
    this.daysEl				= this.createTimePartElement('days');
    this.hoursEl			= this.createTimePartElement('hours');
    this.minsEl				= this.createTimePartElement('mins');
    this.secsEl				= this.createTimePartElement('secs');

    this.daysRemainingEl	= this.daysEl.querySelector('.js-days-remaining');
    this.hoursRemainingEl	= this.hoursEl.querySelector('.js-hours-remaining');
    this.minsRemainingEl	= this.minsEl.querySelector('.js-mins-remaining');
    this.secsRemainingEl	= this.secsEl.querySelector('.js-secs-remaining');
    this.remainingEl		  = timerRemainingEl;

    const timerElClasses = [ 'timer' ];
    if (this.extended === true) {
      timerElClasses.push('timer--extended');
    }
    if (this.compact === true) {
      timerElClasses.push('timer--compact');
    }
    if (this.dark === true) {
      timerElClasses.push('timer--dark');
    }

    addClasses(timerEl, timerElClasses);
    addClasses(timerPartsEl, [ 'timer__parts' ]);
    addClasses(timerDurationEl, [ 'timer__duration' ]);
    addClasses(timerRemainingEl, [ 'timer__duration-remaining', 'js-remaining' ]);

    timerPartsEl.appendChild(this.daysEl);
    timerPartsEl.appendChild(this.hoursEl);
    timerPartsEl.appendChild(this.minsEl);
    timerPartsEl.appendChild(this.secsEl);
    timerDurationEl.appendChild(timerRemainingEl);
    timerEl.appendChild(timerPartsEl);
    timerEl.appendChild(timerDurationEl);
    container.appendChild(timerEl);
  }

  createTimePartElement(timePart) {
    const timePartEl		= document.createElement('span');
    const timePartValueEl	= document.createElement('span');
    const timePartUnitEl	= document.createElement('span');
    timePartEl.classList.add('timer__part');
    timePartValueEl.classList.add('timer__part-value');
    timePartValueEl.classList.add(`js-${ timePart }-remaining`);
    timePartUnitEl.classList.add('timer__part-unit');

    timePartValueEl.innerText	= '00';
    timePartUnitEl.innerText	= this.compact ? timePart.charAt(0) : timePart;

    timePartEl.appendChild(timePartValueEl);
    timePartEl.appendChild(timePartUnitEl);

    return timePartEl;
  }

  renderTimeUnitRemaining(val, elem) {
    const valText = (val < 10) ? `0${ val }` : `${ val }`;
    if (elem.innerText !== valText) {
      elem.innerText = valText;
    }
  }

  startTimer() {
    this.countdownTimer = setInterval(() => {
      this.updateTimer();
    }, 100);
  }

  stopTimer() {
    clearInterval(this.countdownTimer);
  }

  /**
	 * Checks that the timer is still required.
	 * If no longer required, then the timer is stopped.
	 */
  checkTimer() {
    if (Date.now() > this.endDate) {
      this.stopTimer();
    }
  }

  updateTimer() {
    this.checkTimer();
    const { percentRemaining, daysRemaining, hoursRemaining, minsRemaining, secsRemaining } = this.getTimeRemaining();
    this.updateProgressBar(percentRemaining);

    if (daysRemaining === 0) {
      this.muteValue(this.daysEl);
      if (hoursRemaining === 0) {
        this.muteValue(this.hoursEl);
        if (minsRemaining === 0) {
          this.muteValue(this.minsEl);
          if (secsRemaining === 0) {
            this.muteValue(this.secsEl);
          }
        }
      }
    }

    this.renderTimeUnitRemaining(daysRemaining, this.daysRemainingEl);
    this.renderTimeUnitRemaining(hoursRemaining, this.hoursRemainingEl);
    this.renderTimeUnitRemaining(minsRemaining, this.minsRemainingEl);
    this.renderTimeUnitRemaining(secsRemaining, this.secsRemainingEl);

    this.remainingEl.style.width = `${ percentRemaining }%`;
  }

  getTimeRemaining() {
    const NOW = Date.now();
    const totalDuration	= this.endDate - this.startDate;
    // const totalElapsed	= NOW - this.startDate;
    let totalRemaining	= this.endDate - NOW;
    if (totalRemaining < 0) {
      totalRemaining = 0;
    }

    return {
      totalRemaining,
      percentRemaining  : ((totalRemaining / totalDuration) * 100),
      daysRemaining     : Math.floor(totalRemaining / DAY),
      hoursRemaining		: Math.floor((totalRemaining / HOUR) % 24),
      minsRemaining     : Math.floor((totalRemaining / MIN) % 60),
      secsRemaining     : Math.floor((totalRemaining / SEC) % 60),
    };
  }

  muteValue(elem) {
    const muteClass = this.extended ? 'text--disabled' : 'display--none';
    addClasses(elem, [ muteClass ]);
  }

  updateProgressBar(percentRemaining) {
    let color = this.stages[0].color;
    for (const stage of this.stages) {
      if (percentRemaining < stage.percentRemaining) {
        color = stage.color;
        break;
      }
    }
    if (this.remainingEl.style.backgroundColor !== color) {
      this.remainingEl.style.backgroundColor = color;
    }
  }

  destroy() {
    this.close();
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.container) {
      console.warn('CommonUI - Countdown Timer - There\'s no timer found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new countdown timer instance
 * @param  {Object} config
 */
export default function initCountdownTimer(config = {}) {
  const { selector = '.js-timer' } = config;
  return new CountdownTimer(document.querySelector(selector), config);
}



// WEBPACK FOOTER //
// ./js/components/CountdownTimer.js